import { useState } from 'react';
import { navigation } from '../data/navigation';
import logo from '../assets/logo-export-dark.svg';
import './Header.scss';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="header">
      <div className="header__inner">
        <a className="header__brand" href="#top" aria-label="Cipher Works home">
          <img src={logo} alt="Cipher Works" />
        </a>
        <button
          type="button"
          className="header__toggle"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span className="header__toggle-bar" />
          <span className="header__toggle-bar" />
          <span className="header__toggle-bar" />
          <span className="sr-only">Toggle navigation</span>
        </button>
        <nav className={`header__nav ${isOpen ? 'header__nav--open' : ''}`}>
          <ul>
            {navigation.map((item) => (
              <li key={item.href}>
                <a href={item.href} onClick={() => setIsOpen(false)}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a className="header__cta" href="#contact" onClick={() => setIsOpen(false)}>
            Start a Project
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
